import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, resolveDynamicComponent as _resolveDynamicComponent, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1224c6ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "f10wrapper" }
const _hoisted_2 = { class: "f10" }
const _hoisted_3 = { class: "topwrapper" }
const _hoisted_4 = { class: "topinfo" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ishidden-nav" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "nav-tab" }, "基本资料")
], -1))
const _hoisted_6 = { class: "hashwrapper" }
const _hoisted_7 = {
  key: 0,
  class: "time"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footAffirms" }, " 免责声明： 本页面涉及的任何内容及操作仅均来源于第三方，与本平台无关，仅供您参考与学习观摩，该等内容不构成对任何金融产品的购买、抛售或持有的建议，不作为您做出任何投资的依据，您应自主投资决策，自行承担投资风险与损失，投资有风险，入市须谨慎！ ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_UpOutlined = _resolveComponent("UpOutlined")!
  const _component_DownOutlined = _resolveComponent("DownOutlined")!
  const _component_a_anchor_link = _resolveComponent("a-anchor-link")!
  const _component_a_anchor = _resolveComponent("a-anchor")!
  const _component_a_affix = _resolveComponent("a-affix")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_back_top = _resolveComponent("a-back-top")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", {
      class: "wrapper",
      onScroll: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.scrollhashwrapper && _ctx.scrollhashwrapper(...args)))
    }, [
      _createElementVNode("section", _hoisted_2, [
        _createVNode(_component_a_affix, {
          "offset-top": 0,
          target: _ctx.containerRef
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_a_typography_title, { level: 3 }, {
                  default: _withCtx(() => [
                    _createElementVNode("i", null, _toDisplayString(_ctx.currentshares.InstrumentID) + " " + _toDisplayString(_ctx.currentshares.name), 1),
                    _createElementVNode("span", {
                      class: _normalizeClass([
                  _ctx.currentshares.RiseandFall > 0
                    ? 'red'
                    : _ctx.currentshares.RiseandFall < 0
                      ? 'green'
                      : '',
                ])
                    }, [
                      _createElementVNode("strong", {
                        class: _normalizeClass({
                    namalstyle: _ctx.getNumber(_ctx.currentshares.LastPrice) === '—',
                  })
                      }, _toDisplayString(_ctx.getNumber2(_ctx.currentshares.LastPrice)), 3),
                      _createElementVNode("span", {
                        class: _normalizeClass(["RiseandFallarrow", [
                    _ctx.theme,
                    _ctx.currentshares.RiseandFall > 0 ? 'top' : 'bottom',
                  ]])
                      }, null, 2)
                    ], 2)
                  ]),
                  _: 1
                }),
                _createElementVNode("span", {
                  class: _normalizeClass([
                _ctx.currentshares.RiseandFall > 0
                  ? 'red'
                  : _ctx.currentshares.RiseandFall < 0
                    ? 'green'
                    : '',
              ])
                }, _toDisplayString(_ctx.getNumber2(_ctx.currentshares.RiseandFall)), 3),
                _createElementVNode("span", {
                  class: _normalizeClass([
                _ctx.currentshares.increase > 0
                  ? 'red'
                  : _ctx.currentshares.increase < 0
                    ? 'green'
                    : '',
              ])
                }, _toDisplayString(_ctx.currentshares.increase > 0 ? "+" : "") + _toDisplayString(_ctx.getPencent(_ctx.currentshares.increase)), 3),
                _createElementVNode("span", {
                  class: "isopen",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isOpen = !_ctx.isOpen))
                }, [
                  _createTextVNode(_toDisplayString(_ctx.isOpen ? "收起" : "展开") + " ", 1),
                  (_ctx.isOpen)
                    ? (_openBlock(), _createBlock(_component_UpOutlined, { key: 0 }))
                    : (_openBlock(), _createBlock(_component_DownOutlined, { key: 1 }))
                ])
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["ishidden", [_ctx.theme]]),
                style: _normalizeStyle({ height: _ctx.isOpen ? '170px' : '12px' })
              }, [
                _hoisted_5,
                (_openBlock(), _createBlock(_component_a_anchor, {
                  key: _ctx.key,
                  affix: false,
                  "get-container": _ctx.target,
                  "target-offset": 220,
                  onChange: _ctx.changehash
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nav, (item, i) => {
                      return (_openBlock(), _createBlock(_component_a_anchor_link, {
                        key: 'nav' + i,
                        href: '#' + item.key,
                        title: item.title,
                        onClick: _ctx.selecthash
                      }, null, 8, ["href", "title", "onClick"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["get-container", "onChange"]))
              ], 6)
            ])
          ]),
          _: 1
        }, 8, ["target"]),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.wrapNav, (item, i) => {
            return (_openBlock(), _createBlock(_component_a_card, {
              id: item.key,
              key: 'topnav' + i,
              size: "small",
              bordered: false
            }, {
              title: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(item.title), 1),
                (item.time)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, "截止日期：" + _toDisplayString(item.time), 1))
                  : _createCommentVNode("", true)
              ]),
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_resolveDynamicComponent(item.key), {
                  token: _ctx.token,
                  onChageTime: _ctx.chageTime
                }, null, 40, ["token", "onChageTime"]))
              ]),
              _: 2
            }, 1032, ["id"]))
          }), 128)),
          _hoisted_8
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_a_back_top, {
          target: _ctx.target,
          key: _ctx.key
        }, null, 8, ["target"])), [
          [_vShow, _ctx.showbacktop]
        ])
      ])
    ], 32),
    _createVNode(_component_Modal)
  ]))
}